{
  "action": {
    "ok": "OK",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saved": "Guardado",
    "close": "Cerrar",
    "yes": "Sí",
    "no": "No",
    "delete": "Eliminar",
    "remove": "Quitar",
    "add": "Añadir",
    "edit": "Editar",
    "rename": "Renombrar",
    "retry": "Reintentar",
    "reset": "Restablecer",
    "apply": "Aplicar",
    "confirm": "Confirmar",
    "back": "Atrás",
    "next": "Siguiente",
    "done": "Hecho",
    "refresh": "Actualizar",
    "copy": "Copiar",
    "copied": "Copiado",
    "open": "Abrir",
    "start": "Iniciar",
    "stop": "Detener",
    "pause": "Pausar",
    "resume": "Reanudar",
    "continue": "Continuar",
    "clear": "Limpiar",
    "search": "Buscar",
    "loading": "Cargando…",
    "saving": "Guardando…",
    "searchPlaceholder": "Buscar…",
    "always": "Siempre",
    "deny": "Denegar",
    "undo": "Deshacer",
    "all": "Todos"
  },
  "confirm": {
    "title": "Aprobación requerida: {{tool}}",
    "descriptionEdit": "El agente quiere modificar un archivo. Revisa la solicitud a continuación y decide si deseas continuar.",
    "descriptionTool": "El agente quiere ejecutar esta herramienta. Revisa la solicitud a continuación y decide si deseas continuar.",
    "fileModification": "Modificación de archivo",
    "toolExecution": "Ejecución de herramienta",
    "riskSuffix": "riesgo {{risk}}",
    "command": "Comando",
    "inputLabel": "Entrada:",
    "trustSuggestionTitle": "Sugerencia de patrón de confianza",
    "trustSuggestionHint": "Elegir Siempre añadirá a la lista de permitidas las llamadas coincidentes para este proyecto.",
    "yoloDestructiveNote": "YOLO está activado. Este aviso se sigue mostrando porque la solicitud se clasificó como destructiva.",
    "skipApprovalsTitle": "Omitir aprobaciones futuras",
    "skipApprovalsHint": "Activa el modo YOLO y el agente ejecuta sin preguntar. Las operaciones destructivas siguen solicitando confirmación.",
    "enableYoloTitle": "Activar modo YOLO (aprobar automáticamente esta y futuras llamadas no destructivas)",
    "enableYoloBtn": "Activar YOLO",
    "denyAlways": "Denegar siempre",
    "denyAlwaysTitle": "Rechazar esta y todas las futuras llamadas que coincidan con el patrón (d)",
    "noTitle": "Rechazar solo esta llamada (Esc / n)",
    "alwaysTitle": "Aprobar y recordar el patrón para el proyecto (a)",
    "yesTitle": "Aprobar solo esta llamada (y)"
  },
  "status": {
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "connecting": "Conectando…",
    "reconnecting": "Reconectando…",
    "ready": "Listo",
    "error": "Error",
    "offline": "Sin conexión",
    "online": "En línea",
    "live": "En vivo",
    "budgetWarning": "alerta de presupuesto",
    "running": "En ejecución",
    "inProgress": "En progreso",
    "working": "trabajando"
  },
  "time": {
    "justNow": "justo ahora",
    "secondsAgo_one": "hace {{count}} segundo",
    "secondsAgo_other": "hace {{count}} segundos",
    "minutesAgo_one": "hace {{count}} minuto",
    "minutesAgo_other": "hace {{count}} minutos",
    "hoursAgo_one": "hace {{count}} hora",
    "hoursAgo_other": "hace {{count}} horas",
    "daysAgo_one": "hace {{count}} día",
    "daysAgo_other": "hace {{count}} días",
    "compactSecondsAgo": "hace {{count}} s",
    "compactMinutesAgo": "hace {{count}} min",
    "compactHoursAgo": "hace {{count}} h"
  },
  "error": {
    "title": "Algo salió mal",
    "body": "Ocurrió un error de renderizado. Tu sesión sigue activa en el servidor — recargar continuará donde lo dejaste.",
    "reload": "Recargar página",
    "tryAgain": "Reintentar"
  },
  "sparkline": {
    "noActivity": "Sin actividad",
    "noActivityYet": "Aún sin actividad",
    "activityMax": "Sparkline de actividad: máx {{count}} eventos",
    "activityPeak": "Sparkline de actividad — pico {{count}} eventos/intervalo"
  }
}
